import './style.css';
import './node_modules/ol-ext/dist/ol-ext.css'
import './node_modules/ol-layerswitcher/src/ol-layerswitcher.css';
import {Map, View} from 'ol/index.js';
import {Vector as VectorLayer, Group} from 'ol/layer.js';
import {OSM, Vector as VectorSource} from 'ol/source.js';
import {useGeographic} from 'ol/proj.js';
import {Style, Circle, Stroke, Fill, Text} from 'ol/style.js';
import ScaleLine from 'ol/control/ScaleLine.js';
import Projection from 'ol/proj/Projection.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import {bbox as bboxStrategy} from 'ol/loadingstrategy.js';
import { toStringHDMS } from "ol/coordinate";
import LayerTile from 'ol/layer/Tile';
import LayerSwitcher from 'ol-layerswitcher';
import {Select} from 'ol/interaction';
import PopupFeature from 'ol-ext/overlay/PopupFeature';
import * as condition from 'ol/events/condition.js';
(function () {
useGeographic();
const place = [166, -77.3];

var scaleline = new ScaleLine();

var style = new Style({
      image: new Circle({
          radius: 4,
          stroke: new Stroke({
            color: '#646464)',
            width: 1,
          }),
          fill: new Fill({
            color: '#4D4D4D'
          })
      }),
      text: new Text({
          font: 'bold 11px "Open Sans", "Arial Unicode MS", "sans-serif"',
          placement: 'point',
          fill: new Fill({color: '#fff'}),
          stroke: new Stroke({color: '#000', width: 2}),
	  offsetX: -8
      }),
  });

var styleFunction = function(feature) {
  style.getText().setText(feature.get('name'));
  return style;
};

var style3 = new Style({
	        image: new Circle({
			radius: 2,
			stroke: new Stroke({
			color: '#64646480',
			width: 0.5,
			}),
			fill: new Fill({
				color: '#64646480'
			})
		}),
	        text: new Text({
			font: 'bold 11px "Open Sans", "Arial Unicode MS", "sans-serif"',
			placement: 'point',
			fill: new Fill({color: '#fff'}),
			stroke: new Stroke({color: '#000', width: 2}),
			offsetX: -6
		}),
})


var style2 = new Style({
	      image: new Circle({
		                radius: 3,

		                stroke: new Stroke({
					            color: '#C8C8C8',
					            width: 1,
					          }),
		                fill: new Fill({
					            color: '#0000FF'
					          })
		            }),
	      text: new Text({
		                font: 'bold 11px "Open Sans", "Arial Unicode MS", "sans-serif"',
		                placement: 'point',
		                fill: new Fill({color: '#fff'}),
		      		stroke: new Stroke({color: '#000', width: 2}),
		                offsetX: 30
		      
		            }),
	  });

var styleFunction2 = function(feature) {
	  style2.getText().setText(feature.get('english_na'));
	  return style2;
};


const scott_base = new VectorSource({
	    format: new GeoJSON(),
	    url: function(extent) {
		        return "/geoserver/wfs?service=wfs&"+
			                "version=2.0.0&request=GetFeature&typeNames=COMNAP_Antarctic_Facilities_Master&" +
			                "CQL_FILTER=(english_na= 'Scott Base')&outputFormat=application/json&srsname=EPSG:3857&";
		        },
	    strategy: bboxStrategy
});

const sblayer = new VectorLayer({
	   source: scott_base,
	   style: styleFunction2,
	   title: 'Scott Base'
});


var tracker_14 = new VectorSource({
    format: new GeoJSON(),
    url: function(extent) {
    return '/geoserver/wfs?service=wfs&'+
	    'version=2.0.0&request=GetFeature&typeNames=trackers:uoo_ut_0014_latest&' + 
	    'outputFormat=application/json&srsname=EPSG:3857&' +
            'bbox=' + extent.join(',') + ',EPSG:4326';
    },
    strategy: bboxStrategy
});

var trackerlayer14 = new VectorLayer({
   source: tracker_14,
   style: styleFunction,
   title: 'Tracker 14'
});

var tracker_14_all = new VectorSource({
	format: new GeoJSON(),
	url: function(extent) {
		return '/geoserver/wfs?service=wfs&'+
			'version=2.0.0&request=GetFeature&typeNames=trackers:uoo_ut_0014_all&' +
			'outputFormat=application/json&srsname=EPSG:3857&' +
			'bbox=' + extent.join(',') + ',EPSG:4326';
	},
	strategy: bboxStrategy
});

var trackerlayer14all = new VectorLayer({
	                                   source: tracker_14_all,
	                                   style: style3,
	                                   title: 'Tracker 14 all'
});


var TrackerGroup = new Group({
   title: 'Trackers',
   visible: true,
   layers: [trackerlayer14all,trackerlayer14]
});

const tileLayer = new LayerTile({
                        source: new OSM(),
	                title: 'Open StreetMap',
	                type: 'base',
			visible: true,
	                crossOrigin: "anonymous"
                  });


const PlaceGroup = new Group({
	title: 'Place Names',
	combine: false,
	visible: true,
	layers: [sblayer]
	   });


const BaseGroup = new Group({
	title: 'Base Layers',
	combine: false,
	visible: true,
	layers: [tileLayer] //,WMSTile,WMSTile2]
});

// Style function
  function getFeatureStyle (feature) {
    var st= [];
    // Shadow style
    st.push (new Style ({
      image: new olShadow ({
        radius: 15
      })
    }));
    var st1= [];
    // Font style
    st.push ( new ol.style.Style ({
      image: new ol.style.FontSymbol({
        form: "marker", 
        glyph: 'fa-car', 
        radius: 15, 
        offsetY: -15,
        fontSize: .7,
        color: '#fff',
        fill: new ol.style.Fill ({
          color: 'blue'
        }),
        stroke: new ol.style.Stroke ({
          color: '#fff',
          width: 2
        })
      }),
      stroke: new ol.style.Stroke ({
        width: 5,
        color: '#f00'
      }),
      fill: new ol.style.Fill ({
        color: [255, 0, 0, 0.6]
      })
    }));
    return st;
  }

const select = new Select({
  hitTolerance: 5,
  condition: condition.click,
  layers: [trackerlayer14,trackerlayer14all],
});



var popup = new PopupFeature({
  popupClass: 'default anim',
  canFix: true,
  select: select,
  template: function(feature) {
    var coords=feature.getGeometry().getCoordinates()
    console.log(toStringHDMS(coords));
    var properties=feature.getProperties();
    var attributes={};
    for (const [key,value] of Object.entries(properties)) {
      if (key == 'latitude')
        attributes[key] = { 
          title: 'Latitude'
        }
        if (key == 'longitude')
        attributes[key] = { 
          title: 'Longitude'
        }
      if (key == 'devicedatetime')
        attributes[key] = { 
          title: 'Date and Time (UTC)'
        }
      if (key == 'temperature0cm')
        attributes[key] = { 
        title: 'Temperature (\u00B0C)'
        }
    }
    return {
      title: function(feat) {
        return 'Tracker '+feat.get('name');
     },
      attributes: attributes
    }
  }
});
    
var flag=0;
trackerlayer14.getSource().on('change', function(evt){
  var source = evt.target;
  if (source.getState() === 'ready') {
	  if (flag==0) {
		  var feature=source.getFeatures()[0];
		  var coords = feature.getGeometry().flatCoordinates
		  map.getView().setCenter(coords);
		  map.getView().setZoom(10);
		  flag=1;
	  }		  
  }
});

const map = new Map({
  target: 'map',
  overlays: [popup],
  view: new View({
    center: place,
    zoom: 0,
  }),
  projection: new Projection("EPSG:3857"),
  layers: [BaseGroup,PlaceGroup,TrackerGroup]

});
map.addControl(scaleline);
const layerSwitcher = new LayerSwitcher({
    tipLabel: 'Legend', // Optional label for button
    groupSelectStyle: 'children' // Can be 'children' [default], 'group' or 'none'
  });
map.addControl(layerSwitcher);
map.addInteraction(select);
})();

